export enum MainTabIndices {
    Hits = 0,
    Original = 1,
    HTML = 2,
    Page = 3,
    PDF = 4,
    Text = 5,
    Produced = 6,
    Translated = 7,
    Redacted = 8,
    Annotated = 9,
    Compare = 10
}
